import React from 'react';
import { styled } from '@mui/material';
import { SecondaryButton, Text } from 'library';
import { IProviderBusinessOutlaw } from '../models';

export function BannedButton({
    bannedAll,
    bannedLocations,
    setOpenBanModal,
}: {
    bannedAll: boolean;
    bannedLocations: IProviderBusinessOutlaw[];
    setOpenBanModal: (open: boolean) => void;
}) {
    return (
        <ButtonContainer>
            <SecondaryButton
                buttonStyle={{ width: 'fit-content', marginTop: 10 }}
                onClick={() => setOpenBanModal(true)}
            >
                Block this Worker
            </SecondaryButton>
            <Text variant="caption">
                Currently blocked at {bannedAll ? 'all' : bannedLocations?.length ?? 0} locations
            </Text>
        </ButtonContainer>
    );
}

const ButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
});
